import { useSelector } from 'react-redux';
import { getProjectTerritory } from '../../features/project/projectSlice';
import { getTerritoryCode } from '../../features/project/projectInitSlice';

export const useTerritoryCode = () => {
  const projectTerritory = useSelector(getProjectTerritory);
  const selectedTerritory = useSelector(getTerritoryCode);
  return projectTerritory || selectedTerritory;
};
